import { Input, Switch, ToggleContainer } from './styles';

type TogleProps = {
  checked: boolean;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLInputElement>,
  ) => any;
  htmlFor?: string;
  disabled?: boolean;
  label?: string;
};

const ToggleSwitch = ({
  onChange,
  checked,
  htmlFor,
  disabled,
  label,
}: TogleProps) => {
  return (
    <ToggleContainer>
      <label htmlFor={htmlFor}>{label}</label>
      <Input
        name={htmlFor}
        id={htmlFor}
        checked={checked}
        type="checkbox"
        onChange={onChange}
        disabled={disabled}
      />
      <Switch />
    </ToggleContainer>
  );
};

export default ToggleSwitch;
